import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0011a130")

_pushScopeId("data-v-0011a130")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "カルテテンプレート作成", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("カルテテンプレートを保存せずに戻っていいですか？ ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("カルテテンプレートを保存しますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_karte_template_list = _resolveComponent("karte-template-list")
  const _component_karte_template_form = _resolveComponent("karte-template-form")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content, null, {
            left: _withId(() => [
              _createVNode(_component_karte_template_list)
            ]),
            right: _withId(() => [
              _createVNode(_component_karte_template_form)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "normal",
            onClick: _ctx.onBack
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        right: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "warning",
            disabled: !_ctx.editing || !_ctx.dataWrite,
            onClick: _ctx.onSave
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmBackRef",
        onYes: _ctx.yesBack
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmSaveRef",
        onYes: _ctx.yesSave
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})